import { JSONSchema7 } from "json-schema";

export const ExplainClarityTestMetadataSchema: JSONSchema7 = {
  description: "Clarity test explanation.",
  type: "object",
  $schema: "http://json-schema.org/draft-07/schema#",
};
